// Grid/list view switcher, a two-button segmented control. Ported from
// botriq-admin-fe's Robot Portal UI kit so My Robots' grid/list toggle looks
// identical to Fleet's.
import PropTypes from "prop-types";
import { Icon } from "./Icon";

const MODES = [
  ["grid", "layout-grid", "Grid view"],
  ["list", "list", "List view"],
];

export const ViewToggle = ({ view, onChange }) => (
  <div
    style={{
      display: "flex",
      gap: 3,
      padding: 3,
      borderRadius: 9,
      background: "var(--bq-surface2)",
      border: "1px solid var(--bq-border)",
    }}
  >
    {MODES.map(([mode, icon, title]) => {
      const active = view === mode;
      return (
        <button
          key={mode}
          type="button"
          title={title}
          aria-label={title}
          aria-pressed={active}
          onClick={() => onChange(mode)}
          style={{
            width: 30,
            height: 28,
            display: "grid",
            placeItems: "center",
            borderRadius: 6,
            border: "none",
            cursor: "pointer",
            color: active ? "var(--bq-accent)" : "var(--bq-text2)",
            background: active ? "var(--bq-surface)" : "transparent",
            boxShadow: active ? "0 1px 2px rgba(0,0,0,.08)" : "none",
          }}
        >
          <Icon name={icon} size={16} />
        </button>
      );
    })}
  </div>
);

ViewToggle.propTypes = {
  view: PropTypes.oneOf(["grid", "list"]).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ViewToggle;
